import { createApp } from 'vue'
import App from './App.vue'
import './scss/index.scss'

createApp(App).mount('#app')